import * as actionTypes from './actionTypes'

// import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import competencyScoreAxios from '../../axios/competencyScore'
import competencyScoreGroupAxios from '../../axios/competencyScoreGroup'

// competency score group

export const fetchCompetencyScoreGroup = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchCompetencyScoreGroupStart())
    competencyScoreGroupAxios
      .get('', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data
          dispatch(fetchCompetencyScoreGroupSuccess(data))
        }
      })
      .catch(e => {
        dispatch(fetchCompetencyScoreGroupFailed(e))
      })
  }
}

export const fetchCompetencyScoreGroupStart = () => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_GROUP_START
  }
}

export const fetchCompetencyScoreGroupSuccess = records => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_GROUP_SUCCESS,
    records
  }
}

export const fetchCompetencyScoreGroupFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_GROUP_FAILED,
    errorMessage
  }
}

export const fetchCompetencyScoreGroupById = recordId => {
  return dispatch => {
    dispatch(fetchCompetencyScoreGroupStart())
    competencyScoreGroupAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCompetencyScoreGroupByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCompetencyScoreGroupFailed(error))
      })
  }
}

export const fetchCompetencyScoreGroupByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_GROUP_BY_ID_SUCCESS,
    recordData
  }
}

export const fetchCompetencyScoreGroupByIdFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_GROUP_BY_ID_FAILED,
    errorMessage
  }
}

export const clearSelectedCompetencyScoreGroupRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_COMPETENCY_SCORE_GROUP_RECORD
  }
}

export const createCompetencyScoreGroup = (recordData, param) => {
  return dispatch => {
    dispatch(createCompotencyScoreGroupStart())

    competencyScoreGroupAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 200) {
          dispatch(
            enqueueSnackbar({
              message: 'CompetencyScoreGroup Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createCompotencyScoreGroupSuccess())
          dispatch(fetchCompetencyScoreGroup(param))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid CompetencyScoreGroup field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createCompotencyScoreGroupFailed(error))
      })
  }
}

export const createCompotencyScoreGroupStart = () => {
  return {
    type: actionTypes.CREATE_COMPETENCY_SCORE_GROUP_START
  }
}

export const createCompotencyScoreGroupSuccess = () => {
  return {
    type: actionTypes.CREATE_COMPETENCY_SCORE_GROUP_SUCCESS
  }
}

export const createCompotencyScoreGroupFailed = errorMessage => {
  return {
    type: actionTypes.CREATE_COMPETENCY_SCORE_GROUP_FAILED,
    errorMessage
  }
}

export const updateCompetencyScoreGroup = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateCompetencyScoreGroupStart())

    competencyScoreGroupAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'CompetencyScoreGroup Updated',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(updateCompetencyScoreGroupSuccess())
        dispatch(fetchCompetencyScoreGroup(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid CompetencyScoreGroup field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateCompetencyScoreGroupFailed(error))
      })
  }
}

export const updateCompetencyScoreGroupStart = () => {
  return {
    type: actionTypes.UPDATE_COMPETENCY_SCORE_GROUP_START
  }
}

export const updateCompetencyScoreGroupSuccess = () => {
  return {
    type: actionTypes.UPDATE_COMPETENCY_SCORE_GROUP_SUCCESS
  }
}

export const updateCompetencyScoreGroupFailed = errorMessage => {
  return {
    type: actionTypes.UPDATE_COMPETENCY_SCORE_GROUP_FAILED,
    errorMessage
  }
}

export const deleteCompetencyScoreGroup = (recordId, param) => {
  return dispatch => {
    dispatch(deleteCompetencyScoreGroupStart())
    competencyScoreGroupAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'CompetencyScoreGroup Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deleteCompetencyScoreGroupSuccess())
        dispatch(fetchCompetencyScoreGroup(param))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Delete failed',
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteCompetencyScoreGroupFailed(error))
      })
  }
}

export const deleteCompetencyScoreGroupStart = () => {
  return {
    type: actionTypes.DELETE_COMPETENCY_SCORE_GROUP_START
  }
}

export const deleteCompetencyScoreGroupSuccess = () => {
  return {
    type: actionTypes.DELETE_COMPETENCY_SCORE_GROUP_SUCCESS
  }
}

export const deleteCompetencyScoreGroupFailed = errorMessage => {
  return {
    type: actionTypes.DELETE_COMPETENCY_SCORE_GROUP_FAILED,
    errorMessage
  }
}

// competency score
export const fetchCompetencyScore = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchCompetencyScoreStart())
    competencyScoreAxios
      .get('', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data
          dispatch(fetchCompetencyScoreSuccess(data))
        }
      })
      .catch(e => {
        dispatch(fetchCompetencyScoreFailed())
      })
  }
}

export const fetchCompetencyScoreStart = () => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_START
  }
}

export const fetchCompetencyScoreSuccess = records => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_SUCCESS,
    records
  }
}

export const fetchCompetencyScoreFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_FAILED,
    errorMessage
  }
}

export const fetchCompetencyScoreById = recordId => {
  return dispatch => {
    dispatch(fetchCompetencyScoreStart())
    competencyScoreAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCompetencyScoreByIdSuccess(response.data.data[0]))
        }
      })
      .catch(error => {
        dispatch(fetchCompetencyScoreFailed(error))
      })
  }
}

export const fetchCompetencyScoreByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_BY_ID_SUCCESS,
    recordData
  }
}

export const fetchCompetencyScoreByIdFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_BY_ID_FAILED,
    errorMessage
  }
}

export const clearSelectedCompetencyScoreRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_COMPETENCY_SCORE_RECORD
  }
}

export const createCompetencyScore = (recordData, param) => {
  return dispatch => {
    dispatch(createCompotencyScoreStart())

    competencyScoreAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 200) {
          dispatch(
            enqueueSnackbar({
              message: 'CompetencyScore Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createCompotencyScoreSuccess())
          dispatch(fetchCompetencyScoreGroup(param))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid CompetencyScore field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createCompotencyScoreFailed(error))
      })
  }
}

export const createCompotencyScoreStart = () => {
  return {
    type: actionTypes.CREATE_COMPETENCY_SCORE_START
  }
}

export const createCompotencyScoreSuccess = () => {
  return {
    type: actionTypes.CREATE_COMPETENCY_SCORE_SUCCESS
  }
}

export const createCompotencyScoreFailed = errorMessage => {
  return {
    type: actionTypes.CREATE_COMPETENCY_SCORE_FAILED,
    errorMessage
  }
}

export const updateCompetencyScore = (recordId, recordData, param) => {
  return dispatch => {
    dispatch(updateCompetencyScoreStart())
    competencyScoreAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'CompetencyScore Updated',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(updateCompetencyScoreSuccess())
        dispatch(fetchCompetencyScoreGroup(param))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid CompetencyScore field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateCompetencyScoreFailed(error))
      })
  }
}

export const updateCompetencyScoreStart = () => {
  return {
    type: actionTypes.UPDATE_COMPETENCY_SCORE_START
  }
}

export const updateCompetencyScoreSuccess = () => {
  return {
    type: actionTypes.UPDATE_COMPETENCY_SCORE_SUCCESS
  }
}

export const updateCompetencyScoreFailed = errorMessage => {
  return {
    type: actionTypes.UPDATE_COMPETENCY_SCORE_FAILED,
    errorMessage
  }
}

export const deleteCompetencyScore = (recordId, param) => {
  return dispatch => {
    dispatch(deleteCompetencyScoreStart())
    competencyScoreAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'CompetencyScore Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deleteCompetencyScoreSuccess())
        dispatch(fetchCompetencyScoreGroup(param))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Delete failed',
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteCompetencyScoreFailed(error))
      })
  }
}

export const deleteCompetencyScoreStart = () => {
  return {
    type: actionTypes.DELETE_COMPETENCY_SCORE_START
  }
}

export const deleteCompetencyScoreSuccess = () => {
  return {
    type: actionTypes.DELETE_COMPETENCY_SCORE_SUCCESS
  }
}

export const deleteCompetencyScoreFailed = errorMessage => {
  return {
    type: actionTypes.DELETE_COMPETENCY_SCORE_FAILED,
    errorMessage
  }
}
